<template>
  <div class="home">
    <ol class="breadcrumbs">
      <router-link to="/dashboard">Dashboard</router-link> > Enquiries
    </ol>
    <div class="d-sm-flex align-items-top justify-content-start mb-4">
      <h1 class="h3 mb-0 text-gray-800">Enquiries</h1>
    </div>
    <enquiry-table :uncompletedOnly="false"></enquiry-table>
  </div>
</template>

<script>
//import Modal from '../components/Modal.vue'
// Get a RTDB instance

import EnquiryTable from "@/components/EnquiryTable";

export default {
  name: "Enquiry",
  components: {
    EnquiryTable
  },
  data() {
    return {
      contactsRaw: [],
      opened: [],
      users: [],
      contactsClosedRaw: []
    };
  },
  props: {

  },
  computed: {
    
  },
  methods: {
    
  },
  firebase: {
    //  contactsClosedRaw: db
    //  .ref("contactForm")
    //  .orderByChild("contactid")
    //  .limitToLast(50),
  },
};
</script>

